<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gUFCEg/tc-custom/9781466864504.jpg?1732137037028" alt="This image is the cover for the book 1603"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">1603
      </h1>
      <p class="bookDescription body article font2">
        <p><i>1603</i> was the year that Queen Elizabeth I, the last of the Tudors, died. Her cousin, Robert Carey, immediately rode like a demon to Scotland to take the news to James VI. The cataclysmic time of the Stuart monarchy had come and the son of Mary Queen of Scots left Edinburgh for London to claim his throne as James I of England. <br/><br/>Diaries and notes written in <i>1603</i> describe how a resurgence of the plague killed nearly 40,000 people. Priests blamed the sins of the people for the pestilence, witches were strangled and burned and plotters strung up on gate tops. But not all was gloom and violence. From a ship's log we learn of the first precious cargoes of pepper arriving from the East Indies after the establishment of a new spice route; Shakespeare was finishing <i>Othello</i> and Ben Jonson wrote furiously to please a nation thirsting for entertainment. <br/><br/><i>1603</i> was one of the most important and interesting years in British history. In <i>1603: The Death of Queen Elizabeth I, the Return of the Black Plague, the Rise of Shakespeare, Piracy, Witchcraft, and the Birth of the Stuart Era</i>, Christopher Lee, acclaimed author of <i>This Sceptred Isle</i>, unfolds its story from first-hand accounts and original documents to mirror the seminal year in which Britain moved from Tudor medievalism towards the wars, republicanism and regicide that lay ahead.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher Lee
      </h2>
      
      <p class="authorDescription body article"><P><B>Christopher Lee</B> studied history at Cambridge and subsequently became BBC defense correspondent. He is the author of the acclaimed BBC series <I>This Sceptered Isle </I>and has edited Churchill's <I>History of the English-Speaking Peoples</I> from the original four volumes into a single book .</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?52fe5108